/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { Header2 } from '../../styles/Components'
import { AsSeenInWrapper } from './styles'

const images = [
  { logo: '/weddings/bridesLogo.png', alt: 'brides.com' },
  { logo: '/weddings/KnotLogo.png', alt: 'theknot.com' },
  { logo: '/weddings/allureLogo.png', alt: 'allure.com' },
  { logo: '/weddings/instyleLogo.png', alt: 'instyle.com' },
  { logo: '/weddings/bridalguideLogo.png', alt: 'bridalguide.com' }
]

const AsSeenIn = () => {
  return (
    <AsSeenInWrapper>
      <Header2 margin="0 0 32px">As seen in</Header2>
      <div className="bridal-mags">
        {images.map((img, i) => (
          <div key={i} className="wedding-as-seen-logo">
            <img
              src={img.logo} 
              alt={img.alt || 'Bridal-Magazine'} 
            />
          </div>
        ))}
      </div>
    </AsSeenInWrapper>
  )
}

export default AsSeenIn
